/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminControllerDashboard } from '../fn/admin/admin-controller-dashboard';
import { AdminControllerDashboard$Params } from '../fn/admin/admin-controller-dashboard';
import { adminControllerDeleteBucketValidator } from '../fn/admin/admin-controller-delete-bucket-validator';
import { AdminControllerDeleteBucketValidator$Params } from '../fn/admin/admin-controller-delete-bucket-validator';
import { adminControllerDeleteUser } from '../fn/admin/admin-controller-delete-user';
import { AdminControllerDeleteUser$Params } from '../fn/admin/admin-controller-delete-user';
import { adminControllerGetBuckets } from '../fn/admin/admin-controller-get-buckets';
import { AdminControllerGetBuckets$Params } from '../fn/admin/admin-controller-get-buckets';
import { adminControllerGetUser } from '../fn/admin/admin-controller-get-user';
import { AdminControllerGetUser$Params } from '../fn/admin/admin-controller-get-user';
import { adminControllerGetUserBucketValidator } from '../fn/admin/admin-controller-get-user-bucket-validator';
import { AdminControllerGetUserBucketValidator$Params } from '../fn/admin/admin-controller-get-user-bucket-validator';
import { adminControllerGetUserTransactions } from '../fn/admin/admin-controller-get-user-transactions';
import { AdminControllerGetUserTransactions$Params } from '../fn/admin/admin-controller-get-user-transactions';
import { adminControllerPostUser } from '../fn/admin/admin-controller-post-user';
import { AdminControllerPostUser$Params } from '../fn/admin/admin-controller-post-user';
import { adminControllerPostUserBucketValidator } from '../fn/admin/admin-controller-post-user-bucket-validator';
import { AdminControllerPostUserBucketValidator$Params } from '../fn/admin/admin-controller-post-user-bucket-validator';
import { adminControllerPutUser } from '../fn/admin/admin-controller-put-user';
import { AdminControllerPutUser$Params } from '../fn/admin/admin-controller-put-user';
import { adminControllerSearchUsers } from '../fn/admin/admin-controller-search-users';
import { AdminControllerSearchUsers$Params } from '../fn/admin/admin-controller-search-users';
import { adminControllerSetBucketValidatorLimit } from '../fn/admin/admin-controller-set-bucket-validator-limit';
import { AdminControllerSetBucketValidatorLimit$Params } from '../fn/admin/admin-controller-set-bucket-validator-limit';
import { AdminDashboardDto } from '../models/admin-dashboard-dto';
import { BucketModelDto } from '../models/bucket-model-dto';
import { BucketValidatorDto } from '../models/bucket-validator-dto';
import { TransactionDto } from '../models/transaction-dto';
import { UserModelDto } from '../models/user-model-dto';

@Injectable({ providedIn: 'root' })
export class AdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminControllerDashboard()` */
  static readonly AdminControllerDashboardPath = '/admin/dashboard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerDashboard()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDashboard$Response(params?: AdminControllerDashboard$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDashboardDto>> {
    return adminControllerDashboard(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerDashboard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDashboard(params?: AdminControllerDashboard$Params, context?: HttpContext): Observable<AdminDashboardDto> {
    return this.adminControllerDashboard$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDashboardDto>): AdminDashboardDto => r.body)
    );
  }

  /** Path part for operation `adminControllerSearchUsers()` */
  static readonly AdminControllerSearchUsersPath = '/admin/user/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSearchUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerSearchUsers$Response(params: AdminControllerSearchUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModelDto>>> {
    return adminControllerSearchUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSearchUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerSearchUsers(params: AdminControllerSearchUsers$Params, context?: HttpContext): Observable<Array<UserModelDto>> {
    return this.adminControllerSearchUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModelDto>>): Array<UserModelDto> => r.body)
    );
  }

  /** Path part for operation `adminControllerGetUser()` */
  static readonly AdminControllerGetUserPath = '/admin/user/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerGetUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerGetUser$Response(params: AdminControllerGetUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelDto>> {
    return adminControllerGetUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerGetUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerGetUser(params: AdminControllerGetUser$Params, context?: HttpContext): Observable<UserModelDto> {
    return this.adminControllerGetUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelDto>): UserModelDto => r.body)
    );
  }

  /** Path part for operation `adminControllerPutUser()` */
  static readonly AdminControllerPutUserPath = '/admin/user/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerPutUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerPutUser$Response(params: AdminControllerPutUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelDto>> {
    return adminControllerPutUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerPutUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerPutUser(params: AdminControllerPutUser$Params, context?: HttpContext): Observable<UserModelDto> {
    return this.adminControllerPutUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelDto>): UserModelDto => r.body)
    );
  }

  /** Path part for operation `adminControllerDeleteUser()` */
  static readonly AdminControllerDeleteUserPath = '/admin/user/{uuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerDeleteUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDeleteUser$Response(params: AdminControllerDeleteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return adminControllerDeleteUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerDeleteUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDeleteUser(params: AdminControllerDeleteUser$Params, context?: HttpContext): Observable<void> {
    return this.adminControllerDeleteUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminControllerPostUser()` */
  static readonly AdminControllerPostUserPath = '/admin/user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerPostUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerPostUser$Response(params: AdminControllerPostUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelDto>> {
    return adminControllerPostUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerPostUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerPostUser(params: AdminControllerPostUser$Params, context?: HttpContext): Observable<UserModelDto> {
    return this.adminControllerPostUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelDto>): UserModelDto => r.body)
    );
  }

  /** Path part for operation `adminControllerGetUserTransactions()` */
  static readonly AdminControllerGetUserTransactionsPath = '/admin/user/{uuid}/transactions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerGetUserTransactions()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerGetUserTransactions$Response(params: AdminControllerGetUserTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TransactionDto>>> {
    return adminControllerGetUserTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerGetUserTransactions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerGetUserTransactions(params: AdminControllerGetUserTransactions$Params, context?: HttpContext): Observable<Array<TransactionDto>> {
    return this.adminControllerGetUserTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TransactionDto>>): Array<TransactionDto> => r.body)
    );
  }

  /** Path part for operation `adminControllerGetUserBucketValidator()` */
  static readonly AdminControllerGetUserBucketValidatorPath = '/admin/user/{uuid}/bucket-validator';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerGetUserBucketValidator()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerGetUserBucketValidator$Response(params: AdminControllerGetUserBucketValidator$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BucketValidatorDto>>> {
    return adminControllerGetUserBucketValidator(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerGetUserBucketValidator$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerGetUserBucketValidator(params: AdminControllerGetUserBucketValidator$Params, context?: HttpContext): Observable<Array<BucketValidatorDto>> {
    return this.adminControllerGetUserBucketValidator$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BucketValidatorDto>>): Array<BucketValidatorDto> => r.body)
    );
  }

  /** Path part for operation `adminControllerPostUserBucketValidator()` */
  static readonly AdminControllerPostUserBucketValidatorPath = '/admin/user/{uuid}/bucket-validator';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerPostUserBucketValidator()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerPostUserBucketValidator$Response(params: AdminControllerPostUserBucketValidator$Params, context?: HttpContext): Observable<StrictHttpResponse<BucketValidatorDto>> {
    return adminControllerPostUserBucketValidator(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerPostUserBucketValidator$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerPostUserBucketValidator(params: AdminControllerPostUserBucketValidator$Params, context?: HttpContext): Observable<BucketValidatorDto> {
    return this.adminControllerPostUserBucketValidator$Response(params, context).pipe(
      map((r: StrictHttpResponse<BucketValidatorDto>): BucketValidatorDto => r.body)
    );
  }

  /** Path part for operation `adminControllerSetBucketValidatorLimit()` */
  static readonly AdminControllerSetBucketValidatorLimitPath = '/admin/user/{uuid}/bucket-validator/{bucketUuid}/set-limit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSetBucketValidatorLimit()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSetBucketValidatorLimit$Response(params: AdminControllerSetBucketValidatorLimit$Params, context?: HttpContext): Observable<StrictHttpResponse<BucketValidatorDto>> {
    return adminControllerSetBucketValidatorLimit(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSetBucketValidatorLimit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSetBucketValidatorLimit(params: AdminControllerSetBucketValidatorLimit$Params, context?: HttpContext): Observable<BucketValidatorDto> {
    return this.adminControllerSetBucketValidatorLimit$Response(params, context).pipe(
      map((r: StrictHttpResponse<BucketValidatorDto>): BucketValidatorDto => r.body)
    );
  }

  /** Path part for operation `adminControllerDeleteBucketValidator()` */
  static readonly AdminControllerDeleteBucketValidatorPath = '/admin/user/{uuid}/bucket-validator/{bucketUuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerDeleteBucketValidator()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDeleteBucketValidator$Response(params: AdminControllerDeleteBucketValidator$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return adminControllerDeleteBucketValidator(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerDeleteBucketValidator$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDeleteBucketValidator(params: AdminControllerDeleteBucketValidator$Params, context?: HttpContext): Observable<void> {
    return this.adminControllerDeleteBucketValidator$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminControllerGetBuckets()` */
  static readonly AdminControllerGetBucketsPath = '/admin/buckets';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerGetBuckets()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerGetBuckets$Response(params?: AdminControllerGetBuckets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BucketModelDto>>> {
    return adminControllerGetBuckets(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerGetBuckets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerGetBuckets(params?: AdminControllerGetBuckets$Params, context?: HttpContext): Observable<Array<BucketModelDto>> {
    return this.adminControllerGetBuckets$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BucketModelDto>>): Array<BucketModelDto> => r.body)
    );
  }

}
